import { useState } from 'react';
// eslint-disable-next-line import/no-cycle
import liCSS from 'components/MakeModelMenu/liCSS';
import Top from 'components/MakeModelMenu/Top';
import { useTranslation } from 'react-i18next';

import manufacturerLogosSprite from 'public/static/images/manufacturer-logos-sprite.png';
import Make from 'types/Make';
import { ChooseFunction } from './types';

interface Props {
  makes: Make[];
  allMakesAndModelsOption?: boolean;
  choose: ChooseFunction;
  chooseAll: ChooseFunction;
  className?: string;
}

export default function MakesList({
  makes,
  allMakesAndModelsOption,
  choose,
  chooseAll,
  className,
}: Props): JSX.Element {
  const [filter, setFilter] = useState('');
  const { t } = useTranslation();

  function filteredMakes(): Make[] {
    if (!filter) {
      return makes;
    }

    return makes.filter(({ name }) => name.toLowerCase().includes(filter.toLowerCase()));
  }

  return (
    <ul data-makes-list className={className}>
      <Top
        includeAll={allMakesAndModelsOption}
        chooseAll={chooseAll}
        handleFilter={setFilter}
        allText={t('makeModelSearch.allMakes')}
        makeOrModel={'make'}
      />
      {filteredMakes().map((make) => (
        <li
          key={make.name}
          data-make={make.name}
          onClick={(): void => {
            choose(make);
          }}
        >
          <div className="logo-container">
            <div className={`logo logo--${make.name}`} />
          </div>
          <div className="name">{make.name}</div>
        </li>
      ))}
      <style jsx>{liCSS}</style>
      <style jsx>
        {`
          ul {
            margin: 0;
            padding: 0;
          }

          li {
            border-bottom: none;
          }

          .name {
            display: inline-block;
            position: relative;
            top: 4px;
            left: 65px;
          }

          .logo-container {
            position: absolute;
            text-align: center;
            width: 60px;
            height: 60px;
            display: inline-block;
            top: 0;
          }

          .logo {
            background: url('${manufacturerLogosSprite}') no-repeat 0 0;
            background-size: cover;
            display: inline-block;
            height: 60px;
            width: 60px;
            overflow: hidden;
            position: relative;
            vertical-align: middle;
            background-position: 0 60px;
          }

          .logo--Acura {
            background-position: 0 0;
          }
          .logo--Alfa.Romeo {
            background-position: 0 -60px;
          }
          .logo--AM.General {
            background-position: 0 -3840px;
          }
          .logo--Aston.Martin {
            background-position: 0 -180px;
          }
          .logo--Audi {
            background-position: 0 -240px;
          }
          .logo--BMW {
            background-position: 0 -300px;
          }
          .logo--Bentley {
            background-position: 0 -360px;
          }
          .logo--Buick {
            background-position: 0 -420px;
          }
          .logo--Bugatti {
            background-position: 0 -3540px;
          }
          .logo--Cadillac {
            background-position: 0 -480px;
          }
          .logo--Chevrolet {
            background-position: 0 -540px;
          }
          .logo--Chrysler {
            background-position: 0 -600px;
          }
          .logo--Daewoo {
            background-position: 0 -660px;
          }
          .logo--Datsun {
            background-position: 0 -3600px;
          }
          .logo--DeLorean {
            background-position: 0 -3960px;
          }
          .logo--Dodge {
            background-position: 0 -720px;
          }
          .logo--Eagle {
            background-position: 0 -780px;
          }
          .logo--Ferrari {
            background-position: 0 -840px;
          }
          .logo--FIAT {
            background-position: 0 -900px;
          }
          .logo--Fisker {
            background-position: 0 -960px;
          }
          .logo--Ford {
            background-position: 0 -1020px;
          }
          .logo--Genesis {
            background-position: 0 -3900px;
          }
          .logo--Geo {
            background-position: 0 -1140px;
          }
          .logo--GMC {
            background-position: 0 -1080px;
          }
          .logo--Honda {
            background-position: 0 -1200px;
          }
          .logo--HUMMER {
            background-position: 0 -1260px;
          }
          .logo--Hyundai {
            background-position: 0 -1320px;
          }
          .logo--Infiniti {
            background-position: 0 -1380px;
          }
          .logo--Isuzu {
            background-position: 0 -1440px;
          }
          .logo--Jaguar {
            background-position: 0 -1500px;
          }
          .logo--Jeep {
            background-position: 0 -1560px;
          }
          .logo--Karma {
            background-position: 0 -4020px;
          }
          .logo--Kia {
            background-position: 0 -1620px;
          }
          .logo--Lamborghini {
            background-position: 0 -1680px;
          }
          .logo--Land.Rover {
            background-position: 0 -1740px;
          }
          .logo--Lexus {
            background-position: 0 -1800px;
          }
          .logo--Lincoln {
            background-position: 0 -1860px;
          }
          .logo--Lotus {
            background-position: 0 -1920px;
          }
          .logo--MINI {
            background-position: 0 -1980px;
          }
          .logo--Maserati {
            background-position: 0 -2040px;
          }
          .logo--Maybach {
            background-position: 0 -2100px;
          }
          .logo--Mazda {
            background-position: 0 -2160px;
          }
          .logo--McLaren {
            background-position: 0 -3660px;
          }
          .logo--Mercedes-Benz {
            background-position: 0 -2220px;
          }
          .logo--Mercury {
            background-position: 0 -2280px;
          }
          .logo--Mitsubishi {
            background-position: 0 -2340px;
          }
          .logo--Nissan {
            background-position: 0 -2400px;
          }
          .logo--Oldsmobile {
            background-position: 0 -2460px;
          }
          .logo--Panoz {
            background-position: 0 -2520px;
          }
          .logo--Plymouth {
            background-position: 0 -2580px;
          }
          .logo--Pontiac {
            background-position: 0 -2640px;
          }
          .logo--Porsche {
            background-position: 0 -2700px;
          }
          .logo--Ram {
            background-position: 0 -2760px;
          }
          .logo--Rolls-Royce {
            background-position: 0 -2820px;
          }
          .logo--Saab {
            background-position: 0 -2880px;
          }
          .logo--Saturn {
            background-position: 0 -2940px;
          }
          .logo--Scion {
            background-position: 0 -3000px;
          }
          .logo--Smart {
            background-position: 0 -3060px;
          }
          .logo--SRT {
            background-position: 0 -3720px;
          }
          .logo--Sterling {
            background-position: 0 -3780px;
          }
          .logo--Subaru {
            background-position: 0 -3180px;
          }
          .logo--Suzuki {
            background-position: 0 -3240px;
          }
          .logo--Tesla {
            background-position: 0 -3300px;
          }
          .logo--Toyota {
            background-position: 0 -3360px;
          }
          .logo--Volkswagen {
            background-position: 0 -3420px;
          }
          .logo--Volvo {
            background-position: 0 -3480px;
          }
        `}
      </style>
    </ul>
  );
}
